import { Card, Col, Placeholder, Row } from "react-bootstrap";
import { ScanMulti } from "../common/models";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";

export const SectionPalliativeButton = (props: {
    isLoading: boolean,
    idx: number,
    active?: number,
    setActive: (active: number) => void,
    data: any,
    title: string,
    scanMulti?: ScanMulti,
}) => {
    
    const handleClick = () => {
        if (!props.isLoading) {
            props.setActive(props.idx);
        }
    };

    const renderContent = () => {
        if (props.isLoading) {
            return (
                <Placeholder animation="glow">
                    <Placeholder xs={4} />
                </Placeholder>
            );
        }

        if (!props.data) {
            return (
                <Row>
                    <Col className="description-text">
                        No Data Available
                    </Col>
                </Row>
            );
        }

        if (props.data.error) {
            return (
                <Row>
                    <Col className="text-danger description-text">
                        {props.data.error}
                    </Col>
                </Row>
            );
        }

        if (props.data.summary) {
            return (
                <Row>
                    <Col className="description-text">
                        <LLMDashboardMarkdownRenderer 
                            content={props.data.summary} 
                            scanMulti={props.scanMulti} 
                        />
                    </Col>
                </Row>
            );
        }

        // Handle special cases for new sections
        if (props.title === "Critical Gaps") {
            const totalGaps = (props.data.acp_documentation?.length || 0) + 
                             (props.data.clinical_needs?.length || 0) + 
                             (props.data.communication_needs?.length || 0);
            if (totalGaps > 0) {
                return (
                    <Row>
                        <Col className="description-text">
                            {totalGaps} critical gap{totalGaps !== 1 ? 's' : ''} identified requiring immediate attention
                        </Col>
                    </Row>
                );
            }
        }

        if (props.title === "Recommendations") {
            const totalRecs = (props.data.immediate_actions?.length || 0) + 
                             (props.data.care_planning?.length || 0);
            if (totalRecs > 0) {
                return (
                    <Row>
                        <Col className="description-text">
                            {totalRecs} recommendation{totalRecs !== 1 ? 's' : ''} for care improvement
                        </Col>
                    </Row>
                );
            }
        }

        if (props.title === "Unmet Needs" && props.data.status) {
            return (
                <Row>
                    <Col className="description-text">
                        <span className={`badge ${props.data.status === 'likely' ? 'bg-warning text-dark' : props.data.status === 'unlikely' ? 'bg-success' : 'bg-info'}`}>
                            {props.data.status.toUpperCase()}
                        </span>
                        <span className="ms-2">unmet palliative needs</span>
                    </Col>
                </Row>
            );
        }

        return (
            <Row>
                <Col className="description-text text-muted">
                    No summary available
                </Col>
            </Row>
        );
    };

    return (
        <Card 
            onClick={handleClick} 
            className={`notes-section ${props.active === props.idx ? "notes-section-active" : ""} ${props.isLoading ? "disabled" : ""}`}
            style={{ cursor: props.isLoading ? 'not-allowed' : 'pointer' }}
        >
            <Card.Body>
                <Row>
                    <Col>
                        <strong>{props.title}</strong>
                    </Col>
                </Row>
                {renderContent()}
            </Card.Body>
        </Card>
    );
};
